import React, { useEffect, useState } from "react";
import { Divider, Input, Select, Spin, Tabs } from "antd";
import {
  DetailContainer,
  FormItem,
  FormikForm,
} from "../../../StyledComponents/CreateKeyAccountManager";
import { HeadContainer } from "../../../StyledComponents/Dashboard";
import {
  LeftContent,
  BottomContent,
  DetailRow,
} from "../../../StyledComponents/Markup";
import {
  MidContent,
  RightContent,
  RowValue,
  TableInput,
  TableItem,
  TDItem,
  THeadItem,
  THItem,
  Title,
  TitleDiv,
  TitleRow,
  TopButtonDiv,
  TopContent,
  TRItem,
  TableFilter,
} from "../../../StyledComponents/RateManagement";
import SubmitButton from "../Common/SubmitButton";
import { ErrorMessage } from "formik";
import {
  move_rate_archive,
} from "../../../store/Admin/RateManagement/RateManagementSlice";
import { useDispatch } from "react-redux";
import {
  countries_list,
  shipment_list,
  shipport_list,
  state_list,
  updatenotificationdata,
} from "../../../store/Admin/Common/CommonSlice";
import styled from "styled-components";
import * as Yup from "yup";
import {
  formatDate,
  GetContainerSizeLabel,
  handleKeyPress,
} from "../../../functions/Utils";
import { SpinContainer, TextAreaItem } from "../../../StyledComponents/Queries";
import { useLocation } from "react-router-dom";
import SelectSearchCountry from "../Common/SelectSearchCountry";
import SelectSearchState from "../Common/SelectSearchState";
import SelectItem from "../Common/SelectItem";
import SimpleInput from "../Common/SimpleInput";
import { get_vehicle_types } from "../../../store/Admin/VehicleManagement/VehicleManagement";
import { httpinstance } from "../../../axios/api";

const { Option } = Select;
const FUEL_TYPE = [
  { label: "CNG", value: "CNG" },
  { label: "Diesel", value: "DIESEL" },
  { label: "Electric", value: "ELECTRIC" },
];

const validationSchema = Yup.object().shape({
  vehicleType: Yup.string().nullable().required("Vehicle Type is required"),
  country: Yup.string().nullable().required("Country is required"),
  minKm: Yup.number()
    .nullable()
    .min(1, "Minimum KM must be greater than 0")
    .required("Minimum KM is required"),
  maxKm: Yup.number()
    .nullable()
    .min(1, 'Maximum KM  must be greater than 0')
    .required("Maximum KM is required").when("minKm", (minKm, schema) => 
      minKm ? schema.min(minKm + 1, "Maximum KM must be greater than Minimum KM") : schema
    ),
  perKmRate: Yup.number()
    .nullable()
    .min(0.1, "Per KM Rate must be greater than 0")
    .required("Per KM Rate is required"),
});

function FTLTransportationRateDetailManagement(props) {
  const dispatch = useDispatch();
  const [spinner, setSpinner] = useState(false);
  const [loading, setLoading] = useState(true);
  const [type, setType] = useState(props.type);
  const [state, setState] = useState({
    countrie: [],
    state_list: [],
  });
  const [vehicleList , setVehicleList] = useState([])

  const location = useLocation();
  const [isLoad, setIsLoad] = useState(true);
  useEffect(() => {
    if (location.pathname === "/rate-management") {
      if (isLoad === false) {
        props.setPageType("table");
      } else {
        setIsLoad(false);
      }
    }
  }, [location]);

  useEffect(() => {
    dispatch(countries_list())
      .then((res) => {
        // console.log('login res => ',res);
        if (res?.payload?.status === 200) {
          const countries = res?.payload?.data?.data.filter(
            (item, index, arr) => {
              return (
                arr.findIndex((t) => t.country_name === item.country_name) ===
                index
              );
            }
          );
          //   console.log(countries);
          setState((prevState) => {
            return {
              ...prevState,
              countries: countries,
            };
          });
          setLoading(false);
        }
      })
      .catch((err) => {
        console.error(err);
      });
      dispatch(get_vehicle_types(""))
      .then((res) => {
        // console.log('login res => ',res);
        if (res?.payload?.status === 200) {
          const getAllVehicle = res?.payload?.data?.data?.map((item)=> {
            return {
                label : item?.name,
                value : item?._id
            }
          })
          //   console.log(countries);
          setVehicleList(getAllVehicle)
          setLoading(false);
        }
      })
      .catch((err) => {
        console.error(err);
      });
    dispatch(state_list())
      .then((res) => {
        // console.log('login res => ',res);
        if (res?.payload?.status === 200) {
          setState((prevState) => {
            return {
              ...prevState,
              state_list: res?.payload?.data?.data,
            };
          });
          setLoading(false);
        }
      })
      .catch((err) => {
        console.error(err);
      });
  }, []);

  const handleCancel = (resetForm) => {
    setType("view");
    props.setType("view");
    resetForm();
  };

  const handleEdit = () => {
    setType("edit");
    props.setType("edit");
  };
  const handleSelectChange = (e, name, setFieldValue) => {
    setFieldValue([name], e);
  };
  console.log(vehicleList,'vehicleList')

  const initialValues = {
    vehicleType: props.instance?.vehicleType?._id
      ? props.instance?.vehicleType?._id
      : null,
    country: props?.instance?.country ? props?.instance?.country : null,
    minKm: props?.instance?.minKm ? props?.instance?.minKm : 1,
    maxKm: props?.instance?.maxKm ? props?.instance?.maxKm : "",
    perKmRate: props?.instance?.perKmRate ? props?.instance?.perKmRate : 1,
    id: props.instance?._id ? props.instance?._id : "",
  };


  if (loading) {
    return (
      <SpinContainer className="user-quote">
        <Spin />
      </SpinContainer>
    );
  } else {
    return (
      <FormikForm
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={async (values, { resetForm }) => {
          const data = {
            ...values,
            minKm: Number(values.minKm),
            maxKm: Number(values.maxKm),
            perKmRate: Number(values.perKmRate),
          };
          setSpinner(true);
          let states = values.states;
          if (values.country !== "India" && values.country !== "INDIA") {
            states = "";
          }
          try {
            const result =
              type === "edit"
                ? await httpinstance.patch(
                    `transport-rates/${values.id}`,
                    data
                  )
                : await httpinstance.post(
                    `transport-rates`,
                    data
                  );
              
            if (result?.data?.statusCode === 200  || result?.data?.statusCode === 201) {
              let data = {
                message: result.data.message,
                statusCode: 200,
                success: result.data.status,
              };
              dispatch(updatenotificationdata(data));
              setSpinner(false);
              resetForm();
              props.setCallList(true);
              props.setPageType("table");
            }
          } catch (error) {
            console.log(error);
            setSpinner(false);
          }
        }}
      >
        {({
          values,
          setFieldValue,
          handleChange,
          handleBlur,
          resetForm,
          errors,
        }) => (
          <FormItem>
            <DetailContainer>
              <HeadContainer className="flexEnd">
                <TopButtonDiv className="mb-3">
                  {type === "edit" || type === "create" ? (
                    <>
                      {" "}
                      {type === "edit" ? (
                        <SubmitButton
                          type="button"
                          title="Cancel"
                          is_icon={false}
                          handleClick={() => handleCancel(resetForm)}
                        />
                      ) : null}
                      <SubmitButton
                        type="submit"
                        title="save"
                        is_save={true}
                        loading={spinner}
                      />
                    </>
                  ) : (
                    <SubmitButton
                      type="button"
                      title="Edit"
                      icon_type="edit"
                      handleClick={() => handleEdit()}
                    />
                  )}
                </TopButtonDiv>
              </HeadContainer>
              <BottomContent>
                <TopContent>
                  <LeftContent>
                    <DetailRow>
                      <TitleDiv>
                        <TitleRow>Country*</TitleRow>
                      </TitleDiv>
                      {type === "edit" || type === "create" ? (
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            width: "50%",
                          }}
                        >
                          <SelectSearchCountry
                            name="country"
                            value={values.country}
                            setFieldValue={setFieldValue}
                            options={state.countries}
                            width="100%"
                            bradius="8px"
                            placeholder="Country"
                          />
                          <ErrorMessage
                            name="country"
                            component="div"
                            style={{ color: "red", fontSize: "12px" }}
                          />
                        </div>
                      ) : (
                        <RowValue>{values.country}</RowValue>
                      )}
                    </DetailRow>
                    <DetailRow 
                     style={{
                      flexFlow: "column",
                      width: "100%",
  
                  }}>
                      <TitleDiv>
                        <TitleRow>Vehicle Type*</TitleRow>
                      </TitleDiv>
                      {type === "edit" || type === "create" ? (
                    <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      width: "50%",
                      flexShrink: 0, 
                      flexGrow: 1,
                    }}
                  >
                      <SelectItem width={160} bradius="8px"  value={values?.vehicleType} setFieldValue={setFieldValue} name='vehicleType' handleChange={handleChange} options={vehicleList} />
                          <ErrorMessage
                            name="vehicleType"
                            component="div"
                            style={{ color: "red", fontSize: "12px" }}
                          />
                        </div>
                      ) : (
                        <RowValue>{values.country}</RowValue>
                      )}
                    </DetailRow>
                    <DetailRow>
                      <TitleDiv>
                        <TitleRow>MinKm</TitleRow>
                      </TitleDiv>
                      {type === "edit" || type === "create" ? (
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            width: "50%",
                          }}
                        >
                          <Input
                            id="minKm"
                            name="minKm"
                            value={values.minKm}
                            onBlur={handleBlur}
                            size="large"
                            placeholder="MinKm"
                            onChange={handleChange}
                            onKeyPress={handleKeyPress}
                          />
                          <ErrorMessage
                            name="minKm"
                            component="div"
                            style={{ color: "red", fontSize: "12px" }}
                          />
                        </div>
                      ) : (
                        <RowValue>{values.minKm}</RowValue>
                      )}
                    </DetailRow>
                    <DetailRow>
                      <TitleDiv>
                        <TitleRow>MaxKm</TitleRow>
                      </TitleDiv>
                      {type === "edit" || type === "create" ? (
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            width: "50%",
                          }}
                        >
                          <Input
                            id="maxKm"
                            name="maxKm"
                            value={values.maxKm}
                            onBlur={handleBlur}
                            size="large"
                            placeholder="MaxKm"
                            onChange={handleChange}
                            onKeyPress={handleKeyPress}
                          />
                          <ErrorMessage
                            name="maxKm"
                            component="div"
                            style={{ color: "red", fontSize: "12px" }}
                          />
                        </div>
                      ) : (
                        <RowValue>{values.maxKm}</RowValue>
                      )}
                    </DetailRow>
                    <DetailRow>
                      <TitleDiv>
                        <TitleRow>PerKmRate</TitleRow>
                      </TitleDiv>
                      {type === "edit" || type === "create" ? (
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            width: "50%",
                          }}
                        >
                          <Input
                            id="perKmRate"
                            name="perKmRate"
                            value={values.perKmRate}
                            onBlur={handleBlur}
                            size="large"
                            placeholder="PerKmRate"
                            onChange={handleChange}
                            onKeyPress={handleKeyPress}
                          />
                          <ErrorMessage
                            name="perKmRate"
                            component="div"
                            style={{ color: "red", fontSize: "12px" }}
                          />
                        </div>
                      ) : (
                        <RowValue>{values.maxKm}</RowValue>
                      )}
                    </DetailRow>
                  </LeftContent>
                </TopContent>
              </BottomContent>
            </DetailContainer>
          </FormItem>
        )}
      </FormikForm>
    );
  }
}

export default FTLTransportationRateDetailManagement;

const ItemSelect = styled(Select)`
  & .ant-select-selector {
    border-radius: 8px !important;
    padding: ${({ pdg }) => (pdg ? pdg : "unset")};
  }
  & .ant-select-selection-placeholder {
    color: #d9d9d9 !important;
    font-size: 16px;
    font-weight: 400;
  }
  & .ant-select-arrow {
    color: #d9d9d9 !important;
  }
  /* & .ant-select-selection-item {
        font-family: 'Rubik';
        font-style: normal;
        font-weight: 500;
        font-size: 15px;
    } */
`;
